import { render } from "./ProGuardados.vue?vue&type=template&id=bc0b11c8&scoped=true"
import script from "./ProGuardados.vue?vue&type=script&lang=js"
export * from "./ProGuardados.vue?vue&type=script&lang=js"

import "./ProGuardados.vue?vue&type=style&index=0&id=bc0b11c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bc0b11c8"

export default script